module.exports = __webpack_public_path__ + "img/cl.13ae2200.svg";